<h3>
    <a ng-click="editGlobalNotification(item.id)" ng-bind-html="item.subject|cHighlight:highlight"></a>
</h3>
<div style="padding: 5px 0 0 0">
    {{ item.body }}
</div>
<div class="property-container">
    <ul class="workflow-property-list">
        <li>{{'globalNotification.activeUntil'|translate}}: {{ item.activeUntil | cDate }}</li>
    </ul>
</div>
